import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TPropertiesOfPatchChangesForSubcategory } from 'types';
import { properties } from 'appConstants/subcategories';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './index.module.scss';

interface IProps {
	setProperties: (value: TPropertiesOfPatchChangesForSubcategory[]) => void;
	selectedProperties: TPropertiesOfPatchChangesForSubcategory[];
}

export const PropertiesMultipleSelect: React.FC<IProps> = React.memo(({ setProperties, selectedProperties }) => {
	const { t } = useTranslation('form');

	const translatedProperties = useMemo(() => {
		return properties.map((property) => ({ id: property.id, name: t(property.name) }));
	}, [t]);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = selectedProperties.filter((el) => el !== id);
			setProperties(updatedSelectedItems);
		},
		[selectedProperties, setProperties],
	);

	const restaurantsList = useMemo(() => {
		return selectedProperties.map((el) => {
			const label = translatedProperties?.find((item) => item.id === el)?.name || '';

			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [selectedProperties, translatedProperties, handleRemove]);

	return (
		<div className={style.container} data-test="RestaurantsMultipleSelect">
			<MultipleSelect
				setProperties={setProperties}
				properties={translatedProperties}
				selectedProperties={selectedProperties}
			/>
			<div className={style.groupsList}>{restaurantsList}</div>
		</div>
	);
});
